<template>
    <span v-if="onlyDaysLeft" v-bind="$attrs">{{ daysLeft }} </span>
    <span v-else class="page-text--sm grey-6--text line-height-15"> {{ startsAt }} ~ {{ endsAt }} {{ daysLeft }} </span>
</template>

<script>
import dayjs from "dayjs";

const days = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        application: { type: Object, default: () => ({}) },
        onlyDaysLeft: { type: Boolean, default: false },
    },
    computed: {
        startsAt() {
            let { startsAt } = this.application || {};
            return startsAt ? `${dayjs(startsAt).format("YYYY.MM.DD")}(${days[dayjs(startsAt).day()]})` : null;
        },
        endsAt() {
            let { endsAt } = this.application || {};
            return endsAt ? `${dayjs(endsAt).format("YYYY.MM.DD")}(${days[dayjs(endsAt).day()]})` : null;
        },
        daysLeft() {
            let { daysLeft } = this.application || {};

            if (daysLeft < 0) return `D${daysLeft}`;
            if (daysLeft > 0) return "마감";
            if (daysLeft == 0) return "D-Day";

            return "상시모집";
        },
    },
};
</script>

<style></style>
